module.exports = __webpack_public_path__ + "static/media/mountain.8789bf8f.jpg";